import { render, staticRenderFns } from "./HomepageV1.vue?vue&type=template&id=edcc2524&scoped=true"
import script from "./HomepageV1.vue?vue&type=script&lang=js"
export * from "./HomepageV1.vue?vue&type=script&lang=js"
import style0 from "./HomepageV1.vue?vue&type=style&index=0&id=edcc2524&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edcc2524",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edcc2524')) {
      api.createRecord('edcc2524', component.options)
    } else {
      api.reload('edcc2524', component.options)
    }
    module.hot.accept("./HomepageV1.vue?vue&type=template&id=edcc2524&scoped=true", function () {
      api.rerender('edcc2524', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/home/HomepageV1.vue"
export default component.exports